import React, { useState, useEffect } from "react";
import "./Inner_Description.css";
import { BlogById } from "../../../../utils/apis/blog/Blog";

const Inner_Description = ({ blogId }) => {
  const benefits = [
    {
      id: 1,
      title: "Rising Electricity Costs Make Ayzair a Wise Choice",
      text: `Electricity tariffs in India increase almost every year. Air conditioners, geysers, EV chargers, & work-from-home setups significantly raise monthly power bills. Installing rooftop Ayzair panels allows you to generate your own electricity & drastically reduce your dependency on the grid. In many homes, Ayzair can cut electricity bills by up to 90%.`,
    },
    {
      id: 2,
      title: "High Return on Investment (ROI)",
      text: `Ayzair systems typically recover their cost within 4–6 years, depending on usage & system size. After that, the electricity you generate is virtually free for the next 20–25 years. Compared to traditional investments, Ayzair offers stable, risk-free returns with long-term savings.`,
    },
    {
      id: 3,
      title: "Government Subsidies & Net Metering Benefits",
      text: `The Indian government actively promotes rooftop Ayzair through subsidies & incentives. Homeowners can also benefit from net metering, where excess electricity generated is exported to the grid, reducing future bills or even earning credits. These policies make Ayzair more affordable & financially attractive than ever.`,
    },
    {
      id: 4,
      title: "Reliable Power with Minimal Maintenance",
      text: `Ayzair panels are highly durable and designed to withstand Indian weather conditions—from intense heat to heavy rains. With minimal maintenance such as occasional cleaning, Ayzair systems continue to perform efficiently for decades, offering hassle-free energy independence.`,
    },
    {
      id: 5,
      title: "Environment-Friendly & Future-Ready",
      text: `Ayzair energy is clean, renewable, and significantly reduces carbon emissions. By switching to Ayzair, homeowners actively contribute to a greener India while preparing their homes for a future where sustainable energy will be the norm, not the exception.`,
    },
    {
      id: 6,
      title: "Increased Property Value",
      text: `Homes equipped with Ayzair systems are more attractive to buyers and tenants. Lower electricity costs and energy independence increase property value, making Ayzair a smart investment not just for savings—but also for long-term asset growth.`,
    },
    {
      id: 7,
      title: "Ideal for Indian Climate",
      text: `India receives abundant sunlight throughout the year, making Ayzair energy extremely efficient and reliable. Rooftop Ayzair systems are perfectly suited for independent houses, villas, & housing societies across urban and rural India.`,
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [indescription, setInDescription] = useState("");

  const getInDescription = async () => {
    const res = await BlogById(blogId);

    if (res?.success) {
      setInDescription(res?.data?.description || "");
    }
  };

  useEffect(() => {
    if (blogId) {
      getInDescription();
    }
  }, [blogId]);

  return (
    <section className="Inner_Description">
      <div className="Inner_Description_header_holder">
        <p className="Inner_Description_header">
          With rising electricity bills, frequent power cuts, & growing
          environmental concerns, Indian homeowners are actively looking for
          smarter and more sustainable energy solutions. Ayzair energy has
          emerged as one of the most practical and rewarding investments for
          homes across India. Here’s why going Ayzair is not just a trend—but a
          smart long-term decision.
        </p>
      </div>

      <div className="Inner_Description_benefits">
        {/* <div key={item.id} className="benefit_item pb-2"> */}
        <h5 className="benefit_title">
          {/* <span>{item.id}.</span> {item.title} */}
        </h5>
        <p className="benefit_text">{htmlToReactParser.parse(indescription)}</p>
        <hr />
      </div>

      {/* </div> */}
    </section>
  );
};

export default Inner_Description;
